module.exports = __webpack_public_path__ + "static/img/text_icon2.d89076f9.png";